import { render } from "./Pager.vue?vue&type=template&id=578ec909&scoped=true&ts=true"
import script from "./Pager.vue?vue&type=script&lang=ts"
export * from "./Pager.vue?vue&type=script&lang=ts"

import "./Pager.vue?vue&type=style&index=0&id=578ec909&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578ec909"]])

export default __exports__